module.exports = __webpack_public_path__ + "img/070.ab4e5398.png";